import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-recommendations-box',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './recommendations-box.component.html',
  styleUrl: './recommendations-box.component.scss',
})
export class RecommendationsBoxComponent {
  closed = output<void>();

  onClose(): void {
    this.closed.emit();
  }
}
